import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgWizardConfig, STEP_STATE, StepChangedArgs, THEME } from 'ng-wizard';
import { BarcodeScannerLivestreamComponent } from 'ngx-barcode-scanner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { apiEnpoints } from 'src/app/core/helpers/api-endpoints';
import { ApiService } from 'src/app/core/services/api.service';
import { json } from 'stream/consumers';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-barcode-reader',
  templateUrl: './barcode-reader.component.html',
  styleUrl: './barcode-reader.component.scss'
})
export class BarcodeReaderComponent implements OnInit{
  @ViewChild('barcodeInputPkg', { static: false }) barcodeInputPkg!: ElementRef;
  @ViewChild(BarcodeScannerLivestreamComponent)
  barcodeScanner: BarcodeScannerLivestreamComponent;
  breadCrumbItems: Array<{}>;
  barcodeValueEmp = '';
  barcodeValuePkg = '';;
  subscription:Subscription[] = []
  selectedDepartment;
  invalid = false;
  paramValue;
  config: NgWizardConfig = {
    selected: 0,
    theme: THEME.arrows,
    toolbarSettings: {
      toolbarExtraButtons: [
        { text: 'Finish', class: 'btn btn-info', event: () => { alert("Finished!!!"); } }
      ],
    }
  };

  step = 1;
  inputQuantityForm!: FormGroup; // FormGroup instance
  inputSubmitted = false; // Tracks form submission stat

  outputQuantityForm!: FormGroup; // FormGroup instance
  outputSubmitted = false; // Tracks form submission stat
  bundleScannedData;
  inputQuantity;

  stages = [
    {
      "name": "EMP Login",
      "status": "IN_PROGRESS",
    },
    {
      "name": "Input",
      "status": "NOT_STARTED ",
    },
    {
      "name": "Output",
      "status": "NOT_STARTED ",
    }
  ]
  inputValue;
  inputValuePkg;

@ViewChild('barcodeInputEmp', { static: true }) barcodeInputEmp!: ElementRef;

 constructor(
  private modalService: NgbModal,
  private formBuilder: FormBuilder,
  private toastr: ToastrService,
  private ApiService :ApiService,
  private route: ActivatedRoute
) {
  this.config.theme = THEME.circles;
}

  ngOnInit(): void {
    this.generateForm();
    this.route.queryParamMap.subscribe(queryParam => {
      if(queryParam){
        this.paramValue = queryParam.get('department');
        this.fetchData(this.paramValue)
      }else{
        this.invalid = true;
      }
    });
  }

  ngAfterViewInit() {
    // Ensure the input is focused when the component is loaded
    // setTimeout(() => {
    //   this.barcodeInputEmp.nativeElement.focus();
    // }, 1000);
  }

  generateForm(){
    this.inputQuantityForm = this.formBuilder.group({
      inputQuantity: ['', [Validators.required, Validators.min(1)]]
    });

    this.outputQuantityForm = this.formBuilder.group({
      outputQuantity: ['', [Validators.required, Validators.min(1)]],
      printDamageQuantity: ['0'],
      fabricDamageQuantity: ['0'],
      sampleQuantity: ['0']
    });
  }

 // Getter for easy access to form fields
  get f() {
  return this.inputQuantityForm.controls;
  }

   // Getter for easy access to form fields
  get fo() {
    return this.outputQuantityForm.controls;
  }
  

  /**
   * Fetch relevent data
   */
  fetchData(id){
    this.subscription.push(this.ApiService.apiAuthGet(apiEnpoints.getDepartmentById+'?departmentId='+id).subscribe(res=>{
      if(res['code'] == 1){
        this.selectedDepartment = res['bandleDeparment'];
        if(sessionStorage.getItem('employeeId')){
          this.barcodeValueEmp = JSON.parse(sessionStorage.getItem('employeeId'));
          this.stages = [
            {
              "name": "EMP Login",
              "status": "COMPLETED",
            },
            {
              "name": "Input",
              "status": "IN_PROGRESS ",
            },
            {
              "name": "Output",
              "status": "NOT_STARTED ",
            }
          ]
          this.step = 2;
          setTimeout(() => {
            this.barcodeInputPkg.nativeElement.focus();
          }, 1);
        }
      }else{
      }
    },error=>{
      console.log(error);
    }))
  }
  


  startBarcodeSacnner(){
    this.barcodeScanner.start();
  }

  /**
   * 
   * @param result 
   */
  onValueChangesEmpScan(result){
    this.onValueChangesEmp(result.codeResult.code)
  }

  /**
   * 
   * @param result 
   */
  onValueChangesPkgScan(result){
    this.onValueChangesPkg(result.codeResult.code)
  }

  /**
   * 
   */
  onInputChangeEmp(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.inputValue = inputElement.value;
  }
  
  onInputChangePkg(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.inputValuePkg = inputElement.value;
  }


  onValueChangesEmpBarcodeReader(){
    this.onValueChangesEmp(this.inputValue)
  }

  onValueChangesPkgBarcodeReader(){
    this.onValueChangesPkg(this.inputValuePkg);
  }



  /**
   * 
   * @param value 
   */
  onValueChangesEmp(value) {
    this.barcodeScanner.stop();
    this.subscription.push(this.ApiService.apiAuthGet(apiEnpoints.validateEmployeeId+'?employeeId='+value).subscribe(res=>{
      if(res['code'] == 1){
        this.stages = [
          {
            "name": "EMP Login",
            "status": "COMPLETED",
          },
          {
            "name": "Input",
            "status": "IN_PROGRESS ",
          },
          {
            "name": "Output",
            "status": "NOT_STARTED ",
          }
        ]
        this.barcodeScanner.stop();
        this.step = 2
        this.barcodeValueEmp = res.employeeDetail;
        sessionStorage.setItem('employeeId', JSON.stringify(this.barcodeValueEmp));

        setTimeout(() => {
          this.barcodeInputPkg.nativeElement.focus();
        }, 1);


      }else{
        this.barcodeValueEmp = '';
        this.toastr.error(res.message,"Error");
      }
    },error=>{
      console.log(error);
    }))
  }

  onStarted(started) {
    console.log(started);
  }


  onValueChangesPkg(result) {
    this.barcodeScanner.stop();
    this.barcodeValuePkg = result;
    var data = {
      departmentId : this.paramValue,
      bundleBarcodeValue : this.barcodeValuePkg,
      empId : this.barcodeValueEmp['employeeId']
    }
    this.subscription.push(this.ApiService.apiAuthPost(apiEnpoints.getBarcodeStatus,data).subscribe(res=>{
      if(res['code'] == 1){
        this.bundleScannedData = res;
        if(this.bundleScannedData.state == 1){
          this.step = 3
        }
        if(this.bundleScannedData.state == 2){
          this.inputQuantity = this.bundleScannedData.qty;
          this.step = 4;
          this.stages = [
            {
              "name": "EMP Login",
              "status": "COMPLETED",
            },
            {
              "name": "Input",
              "status": "COMPLETED",
            },
            {
              "name": "Output",
              "status": "IN_PROGRESS",
            }
          ]
          this.setupAutoCalculation();
        }
      }else{
        this.barcodeValuePkg = '';
        this.toastr.error(res.message,"Error");
      }
    },error=>{
    }))
  }


  /**
   * On submit
   */
  onSubmit(){
    location.reload();
  }


  /**
   * 
   */
  onInputSubmit(){
    this.inputSubmitted = true;
    if(this.inputQuantityForm.valid){
      var data = {
        departmentId : this.selectedDepartment.id,
        inputQuantity : this.inputQuantityForm.value.inputQuantity,
        bundleId : this.bundleScannedData.bundleID,
        empId : this.barcodeValueEmp['employeeId']
      }
      this.subscription.push(this.ApiService.apiAuthPost(apiEnpoints.submitInput,data).subscribe(res=>{
        if(res['code'] == 1){
          this.step = 4;
          this.inputQuantity = this.inputQuantityForm.value.inputQuantity;
          this.bundleScannedData.qty = this.inputQuantity;
          this.setupAutoCalculation();
          this.stages = [
            {
              "name": "EMP Login",
              "status": "COMPLETED",
            },
            {
              "name": "Input",
              "status": "COMPLETED",
            },
            {
              "name": "Output",
              "status": "IN_PROGRESS",
            }
          ]
        }else{
          this.toastr.error(res.message,"Error");
        }
      },error=>{
        console.log(error);
      }))

    }
  }

  /**
   * 
   */
  onOutputSubmit(){
    this.outputSubmitted = true;
    if(this.outputQuantityForm.valid){
      const outputQuantity = this.outputQuantityForm.value.outputQuantity?this.outputQuantityForm.value.outputQuantity:0;
      const printDamageQuantity = this.outputQuantityForm.value.printDamageQuantity?this.outputQuantityForm.value.printDamageQuantity:0;
      const fabricDamageQuantity = this.outputQuantityForm.value.fabricDamageQuantity?this.outputQuantityForm.value.fabricDamageQuantity:0;
      const sampleQuantity = this.outputQuantityForm.value.sampleQuantity?this.outputQuantityForm.value.sampleQuantity:0; 
  
      let total = 
        parseFloat(outputQuantity) + 
        parseFloat(printDamageQuantity) + 
        parseFloat(fabricDamageQuantity) + 
        parseFloat(sampleQuantity);

        
      if(total == this.inputQuantity){
        var data = {
          departMentId : this.selectedDepartment.id,
          bundleId : this.bundleScannedData.bundleID,
          empId : this.barcodeValueEmp['employeeId'],
          outputQuantity : this.outputQuantityForm.value.outputQuantity ? this.outputQuantityForm.value.outputQuantity : 0,
          printDamageQuantity : this.outputQuantityForm.value.printDamageQuantity ?this.outputQuantityForm.value.printDamageQuantity:0,
          fabricDamageQuantity : this.outputQuantityForm.value.fabricDamageQuantity?this.outputQuantityForm.value.fabricDamageQuantity:0,
          sampleQuantity : this.outputQuantityForm.value.sampleQuantity?this.outputQuantityForm.value.sampleQuantity:0
        }
          this.subscription.push(this.ApiService.apiAuthPost(apiEnpoints.submitOutput,data).subscribe(res=>{
            if(res['code'] == 1){
              this.step = 5;
              this.inputQuantity;
              this.stages = [
                {
                  "name": "EMP Login",
                  "status": "COMPLETED",
                },
                {
                  "name": "Input",
                  "status": "COMPLETED",
                },
                {
                  "name": "Output",
                  "status": "COMPLETED",
                }
              ]
            }else{
              this.toastr.error(res.message,"Error");
            }
          },error=>{
            console.log(error);
          }))
        }else{
          // Swal.fire("ERROR", "The input quantity does not match the output quantity. Please verify your entries.", 'error');
          this.toastr.error("The input quantity does not match the output quantity. Please verify your entries.","Error")
        }
      }

  }

  onReload(){
    location.reload();
  }


  setupAutoCalculation() {
    const calculateOutputQuantity = () => {
      const inputQty = this.bundleScannedData?.qty || 0;

      const values = this.outputQuantityForm.getRawValue(); // includes disabled fields
      const printDamage = +values.printDamageQuantity || 0;
      const fabricDamage = +values.fabricDamageQuantity || 0;
      const sample = +values.sampleQuantity || 0;

      const totalDamage = printDamage + fabricDamage + sample;
      const outputQty = totalDamage === 0 ? inputQty : inputQty - totalDamage;

      this.outputQuantityForm.get('outputQuantity')?.setValue(outputQty < 0 ? 0 : outputQty, { emitEvent: false });
    };

    // Run on init
    calculateOutputQuantity();

    // Run on field value changes
    this.outputQuantityForm.valueChanges.subscribe(() => {
      calculateOutputQuantity();
    });
  }

  onLogout() {
    Swal.fire({
      title: 'Are you sure?',
      text: "You want to logout?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, logout!'
    }).then((result) => {
      if (result.isConfirmed) {
        sessionStorage.clear();
        location.reload();
      }
    });

  }
}
